// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"c1078e53","403":"afa8e3e3","453":"052877a7"}[chunkId] + ".chunk.js";
};